var map = {
	"./microsoft-word.md": [
		5560,
		560
	],
	"./overleaf.md": [
		7537,
		537
	],
	"./quarto.md": [
		4575,
		575
	],
	"./r-markdown.md": [
		4823,
		823
	],
	"./texmaker.md": [
		360,
		360
	],
	"./texstudio.md": [
		848,
		848
	],
	"./typst.md": [
		7189,
		189
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1220;
module.exports = webpackAsyncContext;